import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-about" data-section="about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-12">
                <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                <div className="col-md-12">
                    <div className="about-desc">
                    <span className="heading-meta my-1">About Me</span>
                    <h2 className="colorlib-heading">Who Am I?</h2>
                    <p>I am an computer science student from Indian Institute of Information Technology, Sonepat (<a href = "http://iiitsonepat.ac.in/">IIIT SONEPAT</a>).
                        I love exploring new technologies and often amazed by the progress we as a human species have made so far in the recent years.</p>
                    <p>I am interested in Web-Development and learning new Technologies.I have started reflecting my ideas and thougths through the medium of words 
                        recently so spelling and grammer mistaks are very often.You can write me back 
                        if you spot any.<strong>:P</strong> </p>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
        <section className="colorlib-about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">What I do?</span>
                <h2 className="colorlib-heading">Here are some of my expertise</h2>
            </div>
            </div>
            <div className="row row-pt-md">
            <div className="col-md-3 text-center animate-box">
                <div className="services color-1">
                <span className="icon">
                    <i className="icon-bulb" />
                </span>
                <div className="desc">
                    <h3>Web Development </h3>
                    <p>I have experience in JavaScript, ReactJS, HTML, CSS, Django, JSX, Bootstrap</p>
                </div>
                </div>
            </div>
            <div className="col-md-3 text-center animate-box">
                <div className="services color-3">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3>Data Structures & Algorithms</h3>
                    <p>As coming from the CS background, I have good grasp over fundamental concepts of DSA</p>
                </div>
                </div>
            </div>
            <div className="col-md-3 text-center animate-box">
                <div className="services color-5">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Languages</h3>
                    <p>I know  c , c++ , java(basic) , Python.</p>
                </div>
                </div>
            </div>
            <div className="col-md-3 text-center animate-box">
                <div className="services color-2">
                    <span className="icon">
                        <i className="icon-phone3" />
                    </span>
                    <div className="desc">
                        <h3>Tools used</h3>
                        <p>DevCpp, Android Studio, IDLE, Pycharm, Jupyter Notebook, VS Code ,Sublime Text, Xcode.</p>
                    </div>
                </div>
            </div>
            </div>
        </div>
        </section>
      </div>
    )
  }
}
